// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__35OEC","col":"styles_col__3euLb"};